import { Preferences } from "@capacitor/preferences";

export async function getPreference(key: string): Promise<string | undefined> {
    const pref = (await Preferences.get({ key: key })).value
    if (!pref) return undefined

    return pref
}

export async function setPreference(key: string, value: string): Promise<void> {
    await Preferences.set({key: key, value: value})
}

